import {createUseStyles} from 'react-jss';

const offset = 12;

const fullscreenStyles = {
  transform: 'none',
  position: 'fixed',
  width: '100%',
  height: `${100 - offset}%`,
  top: `${offset}%`,
  bottom: 0,
  left: 0,
  right: 0,
  borderRadius: 0,
};

const fullScreenMobileStyles = props => ({
  ...props.isMobile && fullscreenStyles,
});

const popUpStyles = props => ({
  width: 550,
  maxWidth: '100%',
  maxHeight: '100%',
  ...props.isMobile && fullscreenStyles,
});

const autoSizeStyles = props => ({
  maxWidth: '100%',
  maxHeight: '100%',
  ...props.isMobile && fullscreenStyles,
});

const stickyScaleToContentMobileStyles = {
  top: 'auto',
  height: 'auto',
  maxHeight: `${100 - offset}%`,
  overflow: 'scroll',
};

export default createUseStyles({
  '@keyframes slideUp': {
    from: {
      top: '88%',
    },
    to: {
      top: `${offset}%`,
    },
  },
  
  checkoutOverlay: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    left: '50%',
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    width: '80%',
    maxWidth: 670,
    minHeight: 100,
    maxHeight: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    transform: 'translate(-50%, -50%)',
    background: props => (props.theme.overlayBackgroundColour ? props.theme.overlayBackgroundColour : '#fff'),
    animationName: props => (!props.stickyScaleToContentMobile && props.isMobile) && '$slideUp',
    animationDuration: '0.3s',
  
    extend: props => ({
      ...props.popup && popUpStyles(props),
      ...props.fullscreen && fullscreenStyles,
      ...props.fullscreenMobile && fullScreenMobileStyles(props),
      ...props.autosize && autoSizeStyles(props),
      ...props.stickyScaleToContentMobile && props.isMobile && stickyScaleToContentMobileStyles,
    }),
  },
  checkoutOverlayContent: {
    position: 'relative',
    flex: 'auto',
    padding: props => !props.nopadding && '1em',
    overflowY: 'scroll',
  },
});
